let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("elOuJ")).then(() => parcelRequire('jsPzW'));